/**
 * Utilidades para gestionar el banner de novedades ("release notes").
 *
 * Cada vez que se publiquen funciones nuevas se incrementa
 * CURRENT_RELEASE_VERSION. Los usuarios verán el banner hasta que lo cierren
 * o marquen la opción "No volver a mostrar".
 */

const STORAGE_KEY_PREFIX = "fyp:release-notes-seen:";

export const CURRENT_RELEASE_VERSION = "2026-10-22a";

const storageKey = () => `${STORAGE_KEY_PREFIX}${CURRENT_RELEASE_VERSION}`;

/**
 * Devuelve true si el usuario ya ha descartado el banner de la versión actual.
 */
export const wasReleaseNotesSeen = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(storageKey()) === "true";
  } catch {
    return false;
  }
};

/**
 * Marca la versión actual como vista, de modo que el banner no vuelva a
 * aparecer hasta que se publique una nueva versión.
 */
export const markReleaseNotesSeen = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(storageKey(), "true");
  } catch {
    /* ignore quota errors */
  }
};

/**
 * Limpia el flag de la versión actual. Útil para pruebas o para forzar la
 * reaparición del banner sin cambiar la versión.
 */
export const clearReleaseNotesSeen = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(storageKey());
  } catch {
    /* ignore */
  }
};
